import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { GetUserList } from "../../../actions/UserActions";
import { ExportLicenseAllocation } from "../../../actions/LicenseActions";
const LicenseAllocation = () => {
  const dispatch = useDispatch();
  const userListInfo = useSelector((state) => state.userListInfo.value);
  const [sysMgrs, updateSysMgrs] = useState([]);
  const [admins, updateAdmins] = useState([]);
  const [approvers, updateApprovers] = useState([]);
  const [viewers, updateViewers] = useState([]);
  useEffect(() => {
    if (userListInfo.userList.length === 0) {
      GetUserList(dispatch);
    } else {
      let activeUsers = userListInfo.userList.filter((x) => x.isActive === true);
      updateUsers(activeUsers);
    }
  }, [userListInfo]);
  const updateUsers = (users) => {
    let sysMgrs2 = [];
    let admins2 = [];
    let viewers2 = [];
    let approvers2 = [];
    users.forEach((user) => {
      if (user.isActive) {
        if (user.licenseLevel === 5) {
          sysMgrs2.push(user);
        }
        if (user.licenseLevel === 4) {
          sysMgrs2.push(user);
        }
        if (user.licenseLevel === 3) {
          admins2.push(user);
        }
        if (user.licenseLevel === 2) {
          approvers2.push(user);
        }
        if (user.licenseLevel === 1) {
          viewers2.push(user);
        }
      }
    });
    updateSysMgrs(sysMgrs2);
    updateAdmins(admins2);
    updateApprovers(approvers2);
    updateViewers(viewers2);
  };
  const onExportClick = () => {
    ExportLicenseAllocation(dispatch);
  };
  return /* @__PURE__ */ React.createElement("div", { className: "container" }, /* @__PURE__ */ React.createElement(
    "div",
    {
      style: { maxWidth: "100%", margin: "12px" },
      id: "userInfo",
      className: "card"
    },
    /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid id-card" }), "  ", "License Allocation", /* @__PURE__ */ React.createElement("span", { style: { float: "right" } }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "btn btn-success",
        onClick: onExportClick
      },
      /* @__PURE__ */ React.createElement("i", { className: "fa-solid file-arrow-down" }),
      "Export to Excel"
    ))),
    /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "row" }, /* @__PURE__ */ React.createElement("div", { className: "col-3 p-1" }, /* @__PURE__ */ React.createElement("div", { className: "card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "System Manager"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, sysMgrs.map((user) => /* @__PURE__ */ React.createElement("div", { className: "", key: user.userId }, user.firstName, " ", user.lastName))))), /* @__PURE__ */ React.createElement("div", { className: "col-3 p-1" }, /* @__PURE__ */ React.createElement("div", { className: "card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Admin"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, admins.map((user) => /* @__PURE__ */ React.createElement("div", { className: "", key: user.userId }, user.firstName, " ", user.lastName))))), /* @__PURE__ */ React.createElement("div", { className: "col-3 p-1" }, /* @__PURE__ */ React.createElement("div", { className: "card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Approver"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, approvers.map((user) => /* @__PURE__ */ React.createElement("div", { className: "", key: user.userId }, user.firstName, " ", user.lastName))))), /* @__PURE__ */ React.createElement("div", { className: "col-3 p-1" }, /* @__PURE__ */ React.createElement("div", { className: "card" }, /* @__PURE__ */ React.createElement("div", { className: "card-header" }, "Viewer"), /* @__PURE__ */ React.createElement("div", { className: "card-body" }, viewers.map((user) => /* @__PURE__ */ React.createElement("div", { className: "", key: user.userId }, user.firstName, " ", user.lastName)))))))
  ));
};
export default LicenseAllocation;
